module.exports = __webpack_public_path__ + "img/980068198.1e1ec485.jpg";